import { render, staticRenderFns } from "./BaseAdvertisementStaticPreview.vue?vue&type=template&id=ff17e11e"
import script from "./BaseAdvertisementStaticPreview.vue?vue&type=script&lang=js"
export * from "./BaseAdvertisementStaticPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports